import request from '@/utils/request'

// 客户列表
export function getList(params) {
  return request({
    url:'/Crm.Partner/partnerList',
    method:'get',
    params:params
  })
}

// 客户添加
export function partnerAdd(data) {
  return request({
    url:'/Crm.Partner/partnerAdd',
    method:'post',
    data:data
  })
}

// 客户删除
export function partnerDelete(data) {
  return request({
    url:'/Crm.Partner/partnerDelete',
    method:'post',
    data:data
  })
}

// 客户修改
export function partnerUpdate(data) {
  return request({
    url:'/Crm.Partner/partnerUpdate',
    method:'post',
    data:data
  })
}

// 客户详情
export function partnerView(params) {
  return request({
    url:'/Crm.Partner/partnerView',
    method:'get',
    params:params
  })
}

// 业务客户关联列表
export function partnerBusinessAssociationView(data) {
  return request({
    url:'/Crm.Partner/partnerBusinessAssociationView',
    method:'post',
    data:data
  })
}

// 业务客户关联添加
export function partnerBusinessAssociationAdd(data) {
  return request({
    url:'/Crm.Partner/partnerBusinessAssociationAdd',
    method:'post',
    data:data
  })
}

// 业务客户关联删除
export function partnerBusinessAssociationDelete(data) {
  return request({
    url:'/Crm.Partner/partnerBusinessAssociationDelete',
    method:'post',
    data:data
  })
}

// 业务客户关联修改
export function partnerBusinessAssociationUpdate(data) {
  return request({
    url:'/Crm.Partner/partnerBusinessAssociationUpdate',
    method:'post',
    data:data
  })
}

// 客户地址列表
export function customerAddressList(params) {
  return request({
    url:'/Crm.Partner/customerAddressList',
    method:'get',
    params:params
  })
}

// 地址详情
export function customerAddressView(params) {
  return request({
    url:'/Crm.Partner/customerAddressView',
    method:'get',
    params:params
  })
}

// 客户地址添加
export function addCustomerAddress(data) {
  return request({
    url:'/Crm.Partner/addCustomerAddress',
    method:'post',
    data:data
  })
}

// 客户地址修改
export function customerAddressModification(data) {
  return request({
    url:'/Crm.Partner/customerAddressModification',
    method:'post',
    data:data
  })
}

// 客户地址删除
export function CustomerAddressDeletion(data) {
  return request({
    url:'/Crm.Partner/CustomerAddressDeletion',
    method:'post',
    data:data
  })
}

// 下拉框
export function countriesAndRegions(params) {
  return request({
    url:'/Crm.Partner/countriesAndRegions',
    method:'get',
    params:params
  })
}

// 地区
export function getArea(params) {
  return request({
    url:'/Crm.Partner/region',
    method:'get',
    params:params
  })
}

// 销售组下拉框
export function salesTeam(params) {
  return request({
    url:'/Crm.Partner/salesTeam',
    method:'get',
    params:params
  })
}

// 银行列表
export function bankList(params) {
  return request({
    url:'/Crm.Partner/bankList',
    method:'get',
    params:params
  })
}

// 银行信息添加
export function addBankInformation(data) {
  return request({
    url:'/Crm.Partner/addBankInformation',
    method:'post',
    data:data
  })
}

// 银行信息删除
export function deletionOfBankInformation(data) {
  return request({
    url:'/Crm.Partner/deletionOfBankInformation',
    method:'post',
    data:data
  })
}

// 银行信息修改
export function bankInformationModification(data) {
  return request({
    url:'/Crm.Partner/bankInformationModification',
    method:'post',
    data:data
  })
}

// 银行下拉框
export function bankDropDownBox(params) {
  return request({
    url:'/Crm.Partner/bankDropDownBox',
    method:'get',
    params:params
  })
}

// 银行信息查看
export function bankInformationView(params) {
  return request({
    url:'/Crm.Partner/bankInformationView',
    method:'get',
    params:params
  })
}

// 客户产品收藏夹
export function customerProductFavorites(params) {
  return request({
    url:'/Crm.Partner/customerProductFavorites',
    method:'get',
    params:params
  })
}

// 客户产品购物车
export function customerProductShoppingCart(params) {
  return request({
    url:'/Crm.Partner/customerProductShoppingCart',
    method:'get',
    params:params
  })
}

// 修改状态（客户列表审核）
export function customerExamineAndVerify(data) {
  return request({
    url:'/Crm.Partner/customerExamineAndVerify',
    method:'post',
    data:data
  })
}

// 客户积分菲尔币
export function integralStatistics(params) {
  return request({
    url:'/Crm.Partner/IntegralStatistics',
    method:'get',
    params:params
  })
}

// 账号管理列表
export function customerSubAccountList(params) {
  return request({
    url:'/Crm.Partner/customerSubAccountList',
    method:'get',
    params:params
  })
}
// 新建子账号
export function customerSubAccountAdd(data) {
  return request({
    url:'/Crm.Partner/customerSubAccountAdd',
    method:'post',
    data:data
  })
}
// 修改子账号
export function modifyCustomerSubAccount(data) {
  return request({
    url:'/Crm.Partner/modifyCustomerSubAccount',
    method:'post',
    data:data
  })
}
// 删除子账号
export function deleteCustomerSubAccount(data) {
  return request({
    url:'/Crm.Partner/deleteCustomerSubAccount',
    method:'post',
    data:data
  })
}
// 客户子账号查看详情
export function customerSubAccountDetails(params) {
  return request({
    url:'/Crm.Partner/customerSubAccountDetails',
    method:'get',
    params:params
  })
}
// 修改密码
export function passwordModification(data) {
  return request({
    url:'/Crm.Partner/passwordModification',
    method:'post',
    data:data
  })
}

// 备忘录
export function getMemo(params) {
  return request({
    url:'/Memo/index',
    method:'get',
    params:params
  })
}
// 添加
export function addMemo(params) {
  return request({
    url:'/Memo/add',
    method:'get',
    params:params
  })
}
// 修改
export function updateMemo(params) {
  return request({
    url:'/Memo/update',
    method:'get',
    params:params
  })
}
// 删除
export function deleteMemo(data) {
  return request({
    url:'/Memo/delete',
    method:'post',
    data:data
  })
}

// 楚玉客户购物车
// 列表
export function getShopCart(params) {
  return request({
    url:'/Crm.Partner/getShopCart',
    method:'get',
    params:params
  })
}
// 编辑数量
export function editCartNumber(data) {
  return request({
    url:'/Crm.Partner/editCartNumber',
    method:'post',
    data:data
  })
}
// 编辑备注
export function editCartRemark(data) {
  return request({
    url:'Crm.Partner/editCartRemark',
    method:'post',
    data:data
  })
}
// 删除
export function deleteCart(params) {
  return request({
    url:'/Crm.Partner/deleteCart',
    method:'get',
    params:params
  })
}
// 获取万能密码
export function exemption(data) {
  return request({
    url:'Crm.Partner/exemption',
    method:'post',
    data:data
  })
}


// WEBPACK FOOTER //
// ./src/api/customer.js